/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ConstsAppStatus {
  AppStatusCreated = 1,
  AppStatusPublished = 2,
  AppStatusUnpublished = 3,
}

export enum ConstsAccountSource {
  AccountSourceYouTube = 'YouTube',
  AccountSourceBlogReview = 'Blog / PR Article / Product Review',
  AccountSourceWebSearch = 'Web Search (Google, Bing, etc.)',
  AccountSourceAISearch = 'AI Search (ChatGPT, Gemini, etc.)',
  AccountSourceGitHub = 'GitHub',
  AccountSourceCommunity = 'Community (Reddit, Discord, forums)',
  AccountSourceSocialMedia = 'Social Media (X, LinkedIn, Threads, etc.)',
  AccountSourceFriendReferral = 'Friend / Colleague / Referral',
  AccountSourceOther = 'Other',
}

export enum ConstsSourceRecordEntry {
  SourceRecordEntryRegistration = 'registration',
  SourceRecordEntryContactUs = 'contact_us',
}

export enum ConstsCategoryStatKind {
  CategoryStatKindOrderCount = 1,
  CategoryStatKindRealAmount = 2,
}

export enum ConstsCouponKind {
  CouponKindFullMinus = 1,
  CouponKindDiscount = 2,
}

export enum ConstsDiscountKind {
  DiscountKindCoupon = 100,
  DiscountKindReferral = 101,
}

export enum ConstsDiscussionStatus {
  DiscussionStatusOpen = 1,
  DiscussionStatusClose = 2,
}

export enum ConstsEmailSendKind {
  EmailSendKindSignUp = 1,
  EmailSendKindBind = 2,
  EmailSendKindChangePassword = 3,
  EmailSendKindChangeEmail = 4,
}

export enum ConstsOrderStatus {
  OrderStatusWaitPay = 1,
  OrderStatusCompleted = 2,
  OrderStatusWaitConfirm = 3,
  OrderStatusCanceled = 4,
  OrderStatusExpired = 5,
  OrderStatusPaying = 6,
  OrderStatusFailed = 7,
}

export enum ConstsPaymentMethod {
  PaymentMethodPaypal = 'paypal',
  PaymentMethodLianlian = 'lianlian',
  PaymentMethodStripe = 'stripe',
}

export enum ConstsPlatform {
  PlatformGithub = 'github',
  PlatformGoogle = 'google',
  PlatformDiscord = 'discord',
  PlatformChaitin = 'chaitin',
}

export enum ConstsReferralLevel {
  ReferralLevel1 = 1,
  ReferralLevel2 = 2,
  ReferralLevel3 = 3,
  ReferralLevel4 = 4,
  ReferralLevel5 = 5,
  ReferralLevel6 = 6,
}

export enum ConstsReferralPayoutMethod {
  ReferralPayoutMethodPaypal = 'paypal',
}

export enum ConstsReferralPayoutStatus {
  ReferralPayoutStatusPending = 1,
  ReferralPayoutStatusCompleted = 2,
  ReferralPayoutStatusRejected = 3,
}

export enum ConstsReferralStatus {
  ReferralStatusDisabled = 0,
  ReferralStatusUnjoined = 1,
  ReferralStatusJoined = 2,
}

export enum ConstsStatDuration {
  StatDurationDay = 'day',
  StatDurationWeek = 'week',
  StatDurationMonth = 'month',
  StatDurationYear = 'year',
}

export enum ConstsTimeStatKind {
  TimeStatKindRegister = 1,
  TimeStatKindOrder = 2,
  TimeStatKindRealAmount = 3,
  TimeStatKindConsult = 4,
}

export interface DomainAdminApp {
  /** 应用简介 */
  brief?: string
  /** 应用唯一编码 */
  code?: string
  /** 创建时间 */
  created_at?: number
  /** 应用图标 */
  icon?: string
  id?: number
  /** 应用名称 */
  name?: string
  /** 应用状态 */
  status?: ConstsAppStatus
  /** 应用标签 */
  tags?: string[]
}

export interface DomainApp {
  /** 应用简介 */
  brief?: string
  /** 应用唯一编码 */
  code?: string
  /** 创建时间 */
  created_at?: number
  /** 应用图标 */
  icon?: string
  /** 应用名称 */
  name?: string
  /** 应用状态 */
  status?: ConstsAppStatus
  /** 应用标签 */
  tags?: string[]
}

export interface DomainBindEmailReq {
  code: string
  email: string
}

export interface DomainCategoryStatResp {
  /** 产品订单数 */
  product_order_count?: {
    /** 名称 */
    key?: string
    /** 值 */
    value?: number
  }[]
  /** 产品实收款总额 */
  product_real_amount?: {
    /** 名称 */
    key?: string
    /** 值 */
    value?: number
  }[]
}

export interface DomainChangeEmailReq {
  /** 旧邮箱验证码 */
  code: string
  /** 新邮箱验证码 */
  new_code: string
  /** 新邮箱 */
  new_email: string
}

export interface DomainChangePasswordReq {
  code: string
  email: string
  password: string
}

export interface DomainConsultReq {
  apps?: string[]
  company?: string
  email: string
  gclid?: string
  location?: string
  message?: string
  name: string
  phone?: string
  purpose?: string
}

export interface DomainConsult {
  apps?: string[]
  company?: string
  created_at?: number
  email?: string
  /** Google Ads 点击 ID */
  gclid?: string
  id?: string
  location?: string
  message?: string
  name?: string
  phone?: string
  purpose?: string
}

export interface DomainConsultListResp {
  data?: DomainConsult[]
  has_next_page?: boolean
  total_count?: number
}

export interface DomainCountModel {
  count?: number
  name?: string
}

export interface DomainCoupon {
  /** 优惠券金额 */
  amount?: number
  /** 优惠券码 */
  code?: string
  /** 折扣 */
  discount?: number
  /** 优惠券类型 1:满减 2:折扣 */
  kind?: ConstsCouponKind
  /** 节省金额 */
  saved_amount?: number
  /** 门槛 */
  threshold?: number
}

export interface DomainCreateApiTokenResp {
  token?: string
}

export interface DomainCreateAppReq {
  /** 应用简介 */
  brief: string
  /** 应用唯一标识码, 只能是小写字母和数字 */
  code: string
  /** 应用图标 */
  icon: string
  /** 应用名称 */
  name: string
  /** 应用标签 */
  tags: string[]
}

export interface DomainCreateAppResp {
  /** 应用ID */
  app_id?: number
}

export interface DomainCreateOrderInvoiceReq {
  address?: string
  city?: string
  country?: string
  email: string
  name: string
  order_code: string
}

export interface DomainDiscountInfoResp {
  /** 优惠券 */
  coupon?: DomainCoupon
  /** 折扣类型 100:优惠券 101:推广码 */
  kind?: ConstsDiscountKind
  /** 推广码 */
  referral?: DomainReferralCode
}

export interface DomainDiscussion {
  /** 评论数 */
  comment_count?: number
  /** 正文 */
  content?: string
  created_at?: number
  /** 相关的讨论 */
  discussions?: DomainDiscussion[]
  /** 头象 */
  headimage?: string
  id?: string
  /** 当前用户是否点赞 */
  is_like?: boolean
  /** 是自己创建的 */
  is_self?: boolean
  /** 点赞数 */
  like_count?: number
  /** 状态: 1) 打开 2) 关闭 */
  status?: ConstsDiscussionStatus
  /** 主题 */
  subject?: string
  /** 当前用户是否为管理员 */
  super_user?: boolean
  /** 标签 */
  tags?: string[]
  /** 话题 */
  topics?: string[]
  updated_at?: number
  username?: string
  /** 权重 */
  weight?: number
}

export interface DomainDiscussionComment {
  /** 回复 */
  comments?: DomainDiscussionComment[]
  /** 正文 */
  content?: string
  created_at?: number
  /** 踩数 */
  dislike_count?: number
  /** 头象 */
  headimage?: string
  id?: string
  /** 是否踩 */
  is_dislike?: boolean
  /** 是否点赞 */
  is_like?: boolean
  /** 当前评说属于自己的 */
  is_self?: boolean
  /** 点赞数 */
  like_count?: number
  /** 父节点 */
  parent_id?: string
  /** 当前用户是否为管理员 */
  super_user?: boolean
  updated_at?: number
  /** 用户名 */
  username?: string
}

export interface DomainDiscussionCommentCreateReq {
  /** 评论内容 */
  content?: string
  /** discussion id */
  id?: string
  /** 父节点 */
  parent_id?: string
}

export interface DomainDiscussionCommentListResp {
  comments?: DomainDiscussionComment[]
  has_next_page?: boolean
  next_token?: string
  total_count?: number
}

export interface DomainDiscussionCommentUpdateReq {
  /** 评论内容 */
  content?: string
  /** id */
  id: string
}

export interface DomainDiscussionCreateReq {
  /** 正文 */
  content: string
  /** 主题 */
  subject: string
  /** 话题 */
  topics?: string[]
  /** 权重 */
  weight?: number
}

export interface DomainDiscussionListResp {
  discussions?: DomainDiscussion[]
  has_next_page?: boolean
  next_token?: string
  total_count?: number
}

export interface DomainDiscussionTagCreateReq {
  /** id */
  id: string
  /** 标签 */
  tags?: string[]
}

export interface DomainDiscussionUpdateReq {
  /** 正文 */
  content?: string
  /** id */
  id: string
  /** 状态: 1) 打开 2) 关闭 */
  status?: ConstsDiscussionStatus
  /** 主题 */
  subject?: string
  /** 话题 */
  topics?: string[]
  /** 权重 */
  weight?: number
}

export interface DomainEmailSignUpReq {
  code: string
  email: string
  name: string
  password: string
}

export enum DomainFileKey {
  FileKeyAppIcon = 'app_icon',
  FileKeyUserAvatar = 'avatar',
  FileKeyDiscussion = 'discussion',
}

export interface DomainInviteUserReq {
  /** 用户ID */
  uid: number
}

export interface DomainLianLianPaymentReq {
  /** 卡令牌 */
  card_token: string
  /** 城市 */
  city?: string
  /** 国家缩写，请参照【[附录枚举-国家编码](https://doc.lianlianpay.com/appendix)】 */
  country?: string
  first_name: string
  /** 持卡人姓名 */
  holder_name: string
  last_name: string
  /** 详细地址1 */
  line1?: string
  order_code: string
  /** 邮编 */
  postal_code?: string
  /** 省份，查阅附录省份&缩写，部分国家（美国巴西加拿大）请参照【[附录枚举-州](https://doc.lianlianpay.com/appendix/state)】，其他国家按ISO标准填 */
  state?: string
}

export interface DomainLianLianPaymentResp {
  /** 支付链接 */
  url?: string
}

export interface DomainLianLianTokenResp {
  /** 令牌 */
  token?: string
}

export interface DomainLikeRank {
  /** API Token */
  api_token?: string
  /** 头像 */
  avatar?: string
  /** chaitin */
  chaitin?: DomainUserIdentity
  /** 创建时间 */
  created_at?: number
  /** 邮箱 */
  email?: string
  /** github */
  github?: DomainUserIdentity
  /** google */
  google?: DomainUserIdentity
  /** 用户ID */
  id?: number
  /** 是否是超级用户 */
  is_admin?: boolean
  /** 点赞数 */
  like_sum?: number
  /** 用户名 */
  name?: string
  /** 订单数量 */
  order_count?: number
  /** 权限 */
  permissions?: DomainPermission[]
  /** 排名 */
  rank?: number
}

export interface DomainListAppResp {
  apps?: DomainApp[]
}

export interface DomainListOrderResp {
  orders?: DomainOrder[]
  page?: EntPageInfo
}

export interface DomainListUserResp {
  has_next_page?: boolean
  next_token?: string
  total_count?: number
  /** 用户列表 */
  users?: DomainUser[]
}

export interface DomainLoginReq {
  /** 账号 email */
  account: string
  /** 密码 */
  password: string
}

export interface DomainOAuthURLResp {
  url?: string
}

export interface DomainOrder {
  /** 应用 */
  app?: DomainApp
  /** 数量 */
  count?: number
  /** 优惠券 */
  coupon?: DomainCoupon
  /** 创建时间 */
  created_at?: number
  /** 货币 */
  currency?: string
  /** 订单描述 */
  description?: string
  /** 订单过期时间 */
  expired_at?: number
  /** 外部订单ID */
  external_order_id?: string
  /** 发票 */
  invoice?: DomainOrderInvoice
  /** Google Ads 点击 ID */
  gclid?: string
  /** 是否禁用推广码与优惠券 */
  is_discount_disabled?: boolean
  /** 商品列表 */
  items?: DomainOrderItem[]
  /** 订单编码 */
  order_code?: string
  /** 订单类型 purchase: 首购 renewal: 续购 */
  order_type?: string
  /** 支付方式 paypal, lianlian */
  payment_method?: ConstsPaymentMethod
  /** 支付时间 */
  paymented_at?: number
  /** 实际支付金额 */
  real_amount?: number
  /** 续购来源订单 ID */
  renewal_source_order_id?: string
  /** 推广码 */
  referral?: DomainReferralCode
  /** 服务结束时间 */
  service_end_at?: number
  /** 订单状态 1:待支付 2:已支付 3:待确认 4:已取消 5:已过期 6:支付中 */
  status?: ConstsOrderStatus
  /** 订单标题 */
  subject?: string
  /** 订单总金额 */
  total_amount?: number
  /** 交易ID */
  transaction_id?: string
  /** 更新时间 */
  updated_at?: number
  /** 用户 */
  user?: DomainUser
}

export interface DomainOrderChangeAmountReq {
  /** 金额 */
  amount: number
  /** 订单编号 */
  order_code: string
}

export interface DomainOrderCodeReq {
  /** 是否开启 Stripe 自动续费 */
  auto_renew?: boolean
  /** 折扣券 */
  discount_code?: string
  order_code: string
}

export interface DomainOrderInvoice {
  address?: string
  city?: string
  country?: string
  email?: string
  name?: string
}

export interface DomainOrderItem {
  description?: string
  name: string
  /** 保留两位小数 */
  price: number
  quantity: number
  unit: string
}

export interface DomainOrderListResp {
  data?: DomainOrder[]
  has_next_page?: boolean
  next_token?: string
  total_count?: number
}

export interface DomainPayoutListResp {
  has_next_page?: boolean
  next_token?: string
  /** 提现记录 */
  payouts?: DomainReferralPayout[]
  total_count?: number
}

export interface DomainPayoutUpdateReq {
  /** payout 记录id */
  id: string
  /** 驳回原因 */
  reason?: string
  /** 状态 1: 待发放 2: 已发放 3: 驳回 */
  status: ConstsReferralPayoutStatus
}

export interface DomainPaypalPaymentResp {
  /** 支付链接 */
  url?: string
}

export interface DomainPermission {
  /** 权限id */
  id?: DomainPermissionID
  /** 权限名称 */
  name?: string
}

export enum DomainPermissionID {
  PermissionSuperAdmin = 1,
  PermissionUserDisable = 100,
  PermissionUserList = 101,
  PermissionUserEnable = 102,
  PermissionWriteApp = 200,
  PermissionReadApp = 201,
  PermissionWriteOrder = 1000,
  PermissionReadOrder = 1001,
  PermissionCreateCoupon = 2000,
  PermissionReadCoupon = 2001,
  PermissionAuditCoupon = 2002,
  PermissionWriteReferral = 3000,
  PermissionReadReferral = 3001,
  PermissionWriteInvoice = 4000,
  PermissionReadInvoice = 4001,
  PermissionWriteConsult = 5000,
  PermissionReadConsult = 5001,
}

export interface DomainRankResp {
  /** 我的排名 */
  my_rank?: DomainLikeRank
  /** 排行榜 */
  ranks?: DomainLikeRank[]
}

export interface DomainReferral {
  /** 可提现余额 */
  balance?: number
  /** 推荐码 */
  code?: string
  /** 消费者佣金比例 */
  consumer_percentage?: number
  /** 创建时间 */
  created_at?: number
  /** 与下一级的差额 */
  diff_amount?: number
  /** 冻结余额 */
  frozen_balance?: number
  /** ID */
  id?: string
  /** 等级 L1-L6 */
  level?: ConstsReferralLevel
  /** 提现账号 */
  payout_account?: DomainReferralPayoutAccount
  /** 提现中金额 */
  pending_payout?: number
  /** 推荐佣金比例 */
  referral_percentage?: number
  /** 状态 0: 禁用 1: 未加入 2: 已加入 */
  status?: ConstsReferralStatus
  /** 总提现金额 */
  total_payout?: number
  /** 更新时间 */
  updated_at?: number
  /** 用户 */
  user?: DomainUser
}

export interface DomainReferralCode {
  /** 推广码 */
  code?: string
  /** 折扣 0.01-0.99; 目前推广码都是95折, 所以默认是0.95 */
  discount?: number
  /** 节省金额 */
  saved_amount?: number
}

export interface DomainReferralJoinReq {
  /** 提现账号 */
  payout_account?: string
  /** 提现方式 */
  payout_method?: ConstsReferralPayoutMethod
}

export interface DomainReferralListResp {
  has_next_page?: boolean
  next_token?: string
  /** 推荐列表 */
  referrals?: DomainReferral[]
  total_count?: number
}

export interface DomainReferralOrder {
  /** 金额 */
  amount?: number
  /** 应用名称 */
  app_name?: string
  /** 佣金 */
  commission?: number
  /** 佣金比例 0.0-1.0 */
  commission_rate?: number
  /** 创建时间 */
  created_at?: number
  /** 支付时间 */
  paymented_at?: number
  /** 用户 */
  user?: DomainUser
}

export interface DomainReferralOrderListResp {
  has_next_page?: boolean
  next_token?: string
  /** 推荐订单 */
  orders?: DomainReferralOrder[]
  total_count?: number
}

export interface DomainReferralPayout {
  /** 金额 */
  amount?: number
  /** 创建时间 */
  created_at?: number
  /** ID */
  id?: string
  /** 发放时间 */
  issued_at?: number
  /** 发放方式 paypal */
  payout_method?: ConstsReferralPayoutMethod
  /** 原因 */
  reason?: string
  /** 状态 1: 待发放 2: 已发放 */
  status?: ConstsReferralPayoutStatus
  /** 用户 */
  user?: DomainUser
}

export interface DomainReferralPayoutAccount {
  /** 收款账号 */
  account?: string
  /** ID */
  id?: string
  /** 收款人 */
  payee?: string
  /** 发放方式  paypal */
  payout_method?: ConstsReferralPayoutMethod
}

export interface DomainReferralPayoutListResp {
  has_next_page?: boolean
  next_token?: string
  /** 提现记录 */
  payouts?: DomainReferralPayout[]
  total_count?: number
}

export interface DomainReferralPayoutReq {
  /** 收款账号 */
  account?: string
  /** 提现金额 */
  amount?: number
  /** 收款人 */
  payee?: string
  /** 提现方式 */
  payout_method?: ConstsReferralPayoutMethod
}

export interface DomainSendEmailCodeReq {
  /** 邮箱 */
  email: string
  /** 发送类型 1: 注册 2: 绑定 3: 修改密码 */
  kind?: ConstsEmailSendKind
}

export interface DomainSetPermissionReq {
  /** 权限id列表 */
  permission_ids?: DomainPermissionID[]
  /** 用户sid */
  sid?: string
}

export interface DomainSourceRecord {
  created_at?: number
  entry?: ConstsSourceRecordEntry
  id?: string
  is_new_customer?: boolean
  other_detail?: string
  source?: ConstsAccountSource
  user_id?: number | null
}

export interface DomainSourceRecordListResp {
  data?: DomainSourceRecord[]
  has_next_page?: boolean
  total_count?: number
}

export interface DomainSourceStatResp {
  source_record_count?: {
    key?: string
    value?: number
  }[]
}

export interface DomainStatResp {
  /** 实收款总额 */
  real_amount?: number
  /** 总商机数 */
  total_consult?: number
  /** 总用户数 */
  total_user?: number
}

export interface DomainTimeStatResp {
  /** 商机数 */
  consult?: {
    /** 时间 */
    time?: number
    /** 值 */
    value?: number
  }[]
  /** 订单数 */
  order_count?: {
    /** 时间 */
    time?: number
    /** 值 */
    value?: number
  }[]
  /** 实收款总额 */
  real_amount?: {
    /** 时间 */
    time?: number
    /** 值 */
    value?: number
  }[]
  /** 注册用户数 */
  register?: {
    /** 时间 */
    time?: number
    /** 值 */
    value?: number
  }[]
}

export interface DomainUpdateAppReq {
  /** 应用简介 */
  brief?: string
  /** 应用唯一标识码, 只能是小写字母和数字 */
  code?: string
  /** 应用图标 */
  icon?: string
  /** 应用ID */
  id: number
  /** 应用名称 */
  name?: string
  /** 应用状态 1: 创建 2: 发布 3: 下架 */
  status?: ConstsAppStatus
  /** 应用标签 */
  tags?: string[]
}

export interface DomainUpdateOrderInvoiceReq {
  address?: string
  city?: string
  country?: string
  email?: string
  name?: string
  order_code: string
}

export interface DomainUpdateUserReq {
  avatar_url?: string
  name?: string
}

export interface DomainUploadFileReq {
  /** @format binary */
  file: File
  /** avatar, discussion */
  key: 'avatar' | 'discussion'
}

export interface DomainUploadFileResp {
  url?: string
}

export interface DomainUser {
  /** API Token */
  api_token?: string
  /** 头像 */
  avatar?: string
  /** chaitin */
  chaitin?: DomainUserIdentity
  /** 创建时间 */
  created_at?: number
  /** 邮箱 */
  email?: string
  /** github */
  github?: DomainUserIdentity
  /** google */
  google?: DomainUserIdentity
  /** 用户ID */
  id?: number
  /** 是否是超级用户 */
  is_admin?: boolean
  /** 用户名 */
  name?: string
  /** 订单数量 */
  order_count?: number
  /** 权限 */
  permissions?: DomainPermission[]
}

export interface DomainUserIdentity {
  /** 头像 */
  avatar?: string
  /** 邮箱 */
  email?: string
}

export interface EntPageInfo {
  has_next_page?: boolean
  next_token?: string
  total_count?: number
}

export interface WebResp {
  code?: number
  data?: unknown
  message?: string
}

export interface GetAdminAppDownloadCertParams {
  /** id */
  id?: number
}

export interface PostAdminUploadFilePayload {
  /** @format binary */
  file: File
}

export interface GetAdminOrderListParams {
  /** 应用id */
  app_id?: number
  /** 创建时间排序 asc: 升序 desc: 降序 */
  by_created_at?: string
  /** 支付时间排序 asc: 升序 desc: 降序 */
  by_payment_at?: string
  /** 创建人 */
  creator_name?: string
  /** 结束时间 */
  end_at?: number
  /** 下一页标识 */
  next_token?: string
  /** 订单编号 */
  order_code?: string
  /** 订单类型 purchase: 首购 renewal: 续购 */
  order_type?: 'purchase' | 'renewal'
  /** 分页 */
  page?: number
  /** 付款方式 */
  pay_type?: 'paypal' | 'lianlian' | 'stripe'
  /** 支付时间结束 */
  payment_end_at?: number
  /** 支付时间开始 */
  payment_start_at?: number
  /** 实际支付金额 */
  real_amount?: number
  /** 每页多少条记录 */
  size?: number
  /** 开始时间 */
  start_at?: number
  /** 订单状态 1: 待支付 2: 已支付 3: 待确认 4: 已取消 5: 已过期 6: 支付中 7: 支付失败 */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7
  /** 用户id */
  user_id?: number
  has_marketing_source?: boolean
  marketing_source_id?: number
  marketing_source_type?: 'KOL' | 'Media'
}

export interface GetAdminConsultListParams {
  /** 创建时间排序 asc: 升序 desc: 降序 */
  by_created_at?: string
  /** 公司 */
  company?: string
  /** 邮箱 */
  email?: string
  /** 结束时间 */
  end_at?: number
  /** 姓名 */
  name?: string
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
  /** 开始时间 */
  start_at?: number
}

export interface GetAdminOrderExportParams {
  /** 应用id */
  app_id?: number
  /** 结束时间 */
  end_at?: number
  /** 开始时间 */
  start_at?: number
  has_marketing_source?: boolean
  marketing_source_id?: number
  marketing_source_type?: 'KOL' | 'Media'
  /** 订单状态 1: 待支付 2: 已支付 3: 待确认 4: 已取消 5: 已过期 6: 支付中 7: 支付失败 */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7
}

export interface GetAdminReferralListParams {
  /** 推荐码 */
  code?: string
  /** 结束时间 */
  end_at?: number
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
  /** 开始时间 */
  start_at?: number
  /** 状态 */
  status?: 0 | 1 | 2
}

export interface GetAdminReferralPayoutListParams {
  /** 推荐码 */
  code?: string
  /** 结束时间 */
  end_at?: number
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
  /** 开始时间 */
  start_at?: number
  /** 状态 1: 待发放 2: 已发放 3: 驳回 */
  status?: 1 | 2 | 3
}

export interface GetAdminSourceRecordListParams {
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
}

export interface GetAdminStatCategoryParams {
  /** 结束时间 */
  end_at?: number
  /** 类型，1：订单数，2：实收款总额 */
  kind: 1 | 2
  /** 开始时间 */
  start_at?: number
}

export interface GetAdminStatTimeParams {
  /** 时间范围，如：day, week */
  duration: 'day' | 'week' | 'month' | 'year'
  /** 结束时间 */
  end_at?: number
  /** 类型，1：注册用户数，2：订单数，3：实收款总额，4：商机数 */
  kind: 1 | 2 | 3 | 4
  /** 开始时间 */
  start_at?: number
}

export interface GetAdminUserListParams {
  /** 是否查询所有用户 */
  all?: number
  /** 邮箱 */
  email?: string
  /** 结束时间 */
  end_at?: number
  /** 是否已下单 */
  has_order?: boolean
  has_marketing_source?: boolean
  /** 用户ID */
  id?: number
  marketing_source_id?: number
  marketing_source_type?: 'KOL' | 'Media'
  marketing_source_bind_type?: 'new' | 'reactivation'
  marketing_source_start_at?: number
  marketing_source_end_at?: number
  /** 昵称 */
  name?: string
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
  /** 开始时间 */
  start_at?: number
}

export interface GetAdminUserLoginParams {
  /** 第三方平台 github, google */
  platform: 'github' | 'google' | 'discord' | 'chaitin'
  /** 登录成功后跳转的 URL */
  redirect_url?: string
}

export interface GetDiscussionListParams {
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
  /** 搜索 */
  search?: string
  /** 话题筛选 多个用逗号分开 topic1,topic2 */
  topics?: string
  /** 标签筛选 多个用逗号分开 tag1,tag2 */
  tags?: string
  /** 排序: 默认最新 hot: 热门, mine: 我相关的 */
  sort?: 'new' | 'hot' | 'mine'
}

export interface DeleteDiscussionDeleteParams {
  /** id */
  id: string
}

export interface GetDiscussionCommentListParams {
  /** id */
  id: string
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
}

export interface DeleteDiscussionCommentDeleteParams {
  /** id */
  id: string
}

export interface PostDiscussionCommentDislikeParams {
  /** id */
  id: string
  /** 1: 取消踩 */
  undo?: 1
}

export interface PostDiscussionCommentLikeParams {
  /** id */
  id: string
  /** 1: 取消点赞 */
  undo?: 1
}

export interface GetDiscussionInfoParams {
  /** id */
  id: string
}

export interface GetOrderGetParams {
  /** 折扣券 */
  discount_code?: string
  order_code: string
}

export interface GetOrderDiscountParams {
  code: string
  order_code: string
}

export interface GetOrderListParams {
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
}

export interface GetReferralOrderListParams {
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
}

export interface GetReferralPayoutListParams {
  /** 下一页标识 */
  next_token?: string
  /** 分页 */
  page?: number
  /** 每页多少条记录 */
  size?: number
}

export interface GetUserBindThirdPartyParams {
  /** 第三方平台 github, google */
  platform: 'github' | 'google' | 'discord' | 'chaitin'
  /** 绑定成功后跳转的 URL */
  redirect_url: string
}

export interface GetUserOauthLoginParams {
  /** 第三方平台 github, google */
  platform: 'github' | 'google' | 'discord' | 'chaitin'
  /** 登录成功后跳转的 URL */
  redirect_url?: string
}

export interface GetUserGithubOauthCallbackParams {
  code?: string
  state?: string
}

export interface GetUserGoogleOauthCallbackParams {
  code?: string
  state?: string
}
